import animateScrollTo from 'animated-scroll-to';

export default offset =>
  animateScrollTo(offset, {
    maxDuration: 800,
  });
